export const strongActionVerbs = [
    {
        Verb: "A/B Test",
        Present: "A/B Test",
        Past: "A/B Tested",
        Current: "A/B Testing",
    },
    {
        Verb: "AB Test",
        Present: "AB Test",
        Past: "AB Tested",
        Current: "AB Testing",
    },
    {
        Verb: "Accelerate",
        Present: "Accelerate",
        Past: "Accelerated",
        Current: "Accelerating",
    },
    {
        Verb: "Accomplish",
        Present: "Accomplish",
        Past: "Accomplished",
        Current: "Accomplishing",
    },
    {
        Verb: "Achieve",
        Present: "Achieve",
        Past: "Achieved",
        Current: "Achieving",
    },
    {
        Verb: "Act",
        Present: "Act",
        Past: "Acted",
        Current: "Acting",
    },
    {
        Verb: "Activate",
        Present: "Activate",
        Past: "Activated",
        Current: "Activating",
    },
    {
        Verb: "Adapt",
        Present: "Adapt",
        Past: "Adapted",
        Current: "Adapting",
    },
    {
        Verb: "Add",
        Present: "Add",
        Past: "Added",
        Current: "Adding",
    },
    {
        Verb: "Address",
        Present: "Address",
        Past: "Addressed",
        Current: "Addressing",
    },
    {
        Verb: "Adjudicate",
        Present: "Adjudicate",
        Past: "Adjudicated",
        Current: "Adjudicating",
    },
    {
        Verb: "Administer",
        Present: "Administer",
        Past: "Administered",
        Current: "Administering",
    },
    {
        Verb: "Advertise",
        Present: "Advertise",
        Past: "Advertised",
        Current: "Advertising",
    },
    {
        Verb: "Advise",
        Present: "Advise",
        Past: "Advised",
        Current: "Advising",
    },
    {
        Verb: "Affirm",
        Present: "Affirm",
        Past: "Affirmed",
        Current: "Affirming",
    },
    {
        Verb: "Alleviate",
        Present: "Alleviate",
        Past: "Alleviated",
        Current: "Alleviating",
    },
    {
        Verb: "Allocate",
        Present: "Allocate",
        Past: "Allocated",
        Current: "Allocating",
    },
    {
        Verb: "Amend",
        Present: "Amend",
        Past: "Amended",
        Current: "Amending",
    },
    {
        Verb: "Amplify",
        Present: "Amplify",
        Past: "Amplified",
        Current: "Amplifying",
    },
    {
        Verb: "Analyze",
        Present: "Analyze",
        Past: "Analyzed",
        Current: "Analyzing",
    },
    {
        Verb: "Annotate",
        Present: "Annotate",
        Past: "Annotated",
        Current: "Annotating",
    },
    {
        Verb: "Anticipate",
        Present: "Anticipate",
        Past: "Anticipated",
        Current: "Anticipating",
    },
    {
        Verb: "Appraise",
        Present: "Appraise",
        Past: "Appraised",
        Current: "Appraising",
    },
    {
        Verb: "Apprehend",
        Present: "Apprehend",
        Past: "Apprehended",
        Current: "Apprehending",
    },
    {
        Verb: "Approve",
        Present: "Approve",
        Past: "Approved",
        Current: "Approving",
    },
    {
        Verb: "Arbitrate",
        Present: "Arbitrate",
        Past: "Arbitrated",
        Current: "Arbitrating",
    },
    {
        Verb: "Arrange",
        Present: "Arrange",
        Past: "Arranged",
        Current: "Arranging",
    },
    {
        Verb: "Articulate",
        Present: "Articulate",
        Past: "Articulated",
        Current: "Articulating",
    },
    {
        Verb: "Ascertain",
        Present: "Ascertain",
        Past: "Ascertained",
        Current: "Ascertaining",
    },
    {
        Verb: "Aspire",
        Present: "Aspire",
        Past: "Aspired",
        Current: "Aspiring",
    },
    {
        Verb: "Assemble",
        Present: "Assemble",
        Past: "Assembled",
        Current: "Assembling",
    },
    {
        Verb: "Assert",
        Present: "Assert",
        Past: "Asserted",
        Current: "Asserting",
    },
    {
        Verb: "Assess",
        Present: "Assess",
        Past: "Assessed",
        Current: "Assessing",
    },
    {
        Verb: "Assign",
        Present: "Assign",
        Past: "Assigned",
        Current: "Assigning",
    },
    {
        Verb: "Assimilate",
        Present: "Assimilate",
        Past: "Assimilated",
        Current: "Assimilating",
    },
    {
        Verb: "Assist",
        Present: "Assist",
        Past: "Assisted",
        Current: "Assisting",
    },
    {
        Verb: "Attain",
        Present: "Attain",
        Past: "Attained",
        Current: "Attaining",
    },
    {
        Verb: "Audit",
        Present: "Audit",
        Past: "Audited",
        Current: "Auditing",
    },
    {
        Verb: "Augment",
        Present: "Augment",
        Past: "Augmented",
        Current: "Augmenting",
    },
    {
        Verb: "Authenticate",
        Present: "Authenticate",
        Past: "Authenticated",
        Current: "Authenticating",
    },
    {
        Verb: "Author",
        Present: "Author",
        Past: "Authored",
        Current: "Authoring",
    },
    {
        Verb: "Authorize",
        Present: "Authorize",
        Past: "Authorized",
        Current: "Authorizing",
    },
    {
        Verb: "Avail",
        Present: "Avail",
        Past: "Availed",
        Current: "Availing",
    },
    {
        Verb: "Avert",
        Present: "Avert",
        Past: "Averted",
        Current: "Averting",
    },
    {
        Verb: "Balance",
        Present: "Balance",
        Past: "Balanced",
        Current: "Balancing",
    },
    {
        Verb: "Benchmark",
        Present: "Benchmark",
        Past: "Benchmarked",
        Current: "Benchmarking",
    },
    {
        Verb: "Bolster",
        Present: "Bolster",
        Past: "Bolstered",
        Current: "Bolstering",
    },
    {
        Verb: "Bootstrap",
        Present: "Bootstrap",
        Past: "Bootstrapped",
        Current: "Bootstrapping",
    },
    {
        Verb: "Brainstorm",
        Present: "Brainstorm",
        Past: "Brainstormed",
        Current: "Brainstorming",
    },
    {
        Verb: "Broaden",
        Present: "Broaden",
        Past: "Broadened",
        Current: "Broadening",
    },
    {
        Verb: "Broker",
        Present: "Broker",
        Past: "Brokered",
        Current: "Brokering",
    },
    {
        Verb: "Budget",
        Present: "Budget",
        Past: "Budgeted",
        Current: "Budgeting",
    },
    {
        Verb: "Build",
        Present: "Build",
        Past: "Built",
        Current: "Building",
    },
    {
        Verb: "Calculate",
        Present: "Calculate",
        Past: "Calculated",
        Current: "Calculating",
    },
    {
        Verb: "Calibrate",
        Present: "Calibrate",
        Past: "Calibrated",
        Current: "Calibrating",
    },
    {
        Verb: "Capitalize",
        Present: "Capitalize",
        Past: "Capitalized",
        Current: "Capitalizing",
    },
    {
        Verb: "Capture",
        Present: "Capture",
        Past: "Captured",
        Current: "Capturing",
    },
    {
        Verb: "Catalog",
        Present: "Catalog",
        Past: "Cataloged",
        Current: "Cataloging",
    },
    {
        Verb: "Catalog",
        Present: "Catalog",
        Past: "Catalogued",
        Current: "Cataloguing",
    },
    {
        Verb: "Catalogue",
        Present: "Catalogue",
        Past: "Catalogued",
        Current: "Cataloguing",
    },
    {
        Verb: "Categorize",
        Present: "Categorize",
        Past: "Categorized",
        Current: "Categorizing",
    },
    {
        Verb: "Centralize",
        Present: "Centralize",
        Past: "Centralized",
        Current: "Centralizing",
    },
    {
        Verb: "Chair",
        Present: "Chair",
        Past: "Chaired",
        Current: "Chairing",
    },
    {
        Verb: "Champion",
        Present: "Champion",
        Past: "Championed",
        Current: "Championing",
    },
    {
        Verb: "Change",
        Present: "Change",
        Past: "Changed",
        Current: "Changing",
    },
    {
        Verb: "Characterize",
        Present: "Characterize",
        Past: "Characterized",
        Current: "Characterizing",
    },
    {
        Verb: "Choreograph",
        Present: "Choreograph",
        Past: "Choreographed",
        Current: "Choreographing",
    },
    {
        Verb: "Circulate",
        Present: "Circulate",
        Past: "Circulated",
        Current: "Circulateing",
    },
    {
        Verb: "Cite",
        Present: "Cite",
        Past: "Cited",
        Current: "Citing",
    },
    {
        Verb: "Clarify",
        Present: "Clarify",
        Past: "Clarified",
        Current: "Clarifying",
    },
    {
        Verb: "Classify",
        Present: "Classify",
        Past: "Classified",
        Current: "Classifying",
    },
    {
        Verb: "Click",
        Present: "Click",
        Past: "Clicked",
        Current: "Clicking",
    },
    {
        Verb: "Climb",
        Present: "Climb",
        Past: "Climbed",
        Current: "Climbing",
    },
    {
        Verb: "Clone",
        Present: "Clone",
        Past: "Cloned",
        Current: "Cloning",
    },
    {
        Verb: "Coach",
        Present: "Coach",
        Past: "Coached",
        Current: "Coaching",
    },
    {
        Verb: "Code",
        Present: "Code",
        Past: "Coded",
        Current: "Coding",
    },
    {
        Verb: "Coin",
        Present: "Coin",
        Past: "Coined",
        Current: "Coining",
    },
    {
        Verb: "Collaborate",
        Present: "Collaborate",
        Past: "Collaborated",
        Current: "Collaborating",
    },
    {
        Verb: "Collate",
        Present: "Collate",
        Past: "Collated",
        Current: "Collateing",
    },
    {
        Verb: "Collect",
        Present: "Collect",
        Past: "Collected",
        Current: "Collecting",
    },
    {
        Verb: "Commence",
        Present: "Commence",
        Past: "Commenced",
        Current: "Commencing",
    },
    {
        Verb: "Commission",
        Present: "Commission",
        Past: "Commissioned",
        Current: "Commissioning",
    },
    {
        Verb: "Communicate",
        Present: "Communicate",
        Past: "Communicated",
        Current: "Communicating",
    },
    {
        Verb: "Compare",
        Present: "Compare",
        Past: "Compared",
        Current: "Comparing",
    },
    {
        Verb: "Compel",
        Present: "Compel",
        Past: "Compelled",
        Current: "Compelling",
    },
    {
        Verb: "Compile",
        Present: "Compile",
        Past: "Compiled",
        Current: "Compiling",
    },
    {
        Verb: "Complete",
        Present: "Complete",
        Past: "Completed",
        Current: "Completing",
    },
    {
        Verb: "Comply",
        Present: "Comply",
        Past: "Complied",
        Current: "Complying",
    },
    {
        Verb: "Compose",
        Present: "Compose",
        Past: "Composed",
        Current: "Composing",
    },
    {
        Verb: "Compute",
        Present: "Compute",
        Past: "Computed",
        Current: "Computing",
    },
    {
        Verb: "Conceive",
        Present: "Conceive",
        Past: "Conceived",
        Current: "Conceiving",
    },
    {
        Verb: "Conceptualize",
        Present: "Conceptualize",
        Past: "Conceptualized",
        Current: "Conceptualizing",
    },
    {
        Verb: "Conclude",
        Present: "Conclude",
        Past: "Concluded",
        Current: "Concluding",
    },
    {
        Verb: "Concur",
        Present: "Concur",
        Past: "Conquered",
        Current: "Concurring",
    },
    {
        Verb: "Condense",
        Present: "Condense",
        Past: "Condensed",
        Current: "Condensing",
    },
    {
        Verb: "Conduct",
        Present: "Conduct",
        Past: "Conducted",
        Current: "Conducting",
    },
    {
        Verb: "Confer",
        Present: "Confer",
        Past: "Conferred",
        Current: "Conferring",
    },
    {
        Verb: "Configure",
        Present: "Configure",
        Past: "Configured",
        Current: "Configuring",
    },
    {
        Verb: "Confine",
        Present: "Confine",
        Past: "Confined",
        Current: "Confinement",
    },
    {
        Verb: "Confirm",
        Present: "Confirm",
        Past: "Confirmed",
        Current: "Confirming",
    },
    {
        Verb: "Conjoin",
        Present: "Conjoin",
        Past: "Conjoined",
        Current: "Conjoining",
    },
    {
        Verb: "Consent",
        Present: "Consent",
        Past: "Consented",
        Current: "Consenting",
    },
    {
        Verb: "Conservate",
        Present: "Conservate",
        Past: "Conservated",
        Current: "Conservateing",
    },
    {
        Verb: "Consolidate",
        Present: "Consolidate",
        Past: "Consolidated",
        Current: "Consolidating",
    },
    {
        Verb: "Construct",
        Present: "Construct",
        Past: "Constructed",
        Current: "Constructing",
    },
    {
        Verb: "Construe",
        Present: "Construe",
        Past: "Construed",
        Current: "Construing",
    },
    {
        Verb: "Contemplate",
        Present: "Contemplate",
        Past: "Contemplated",
        Current: "Contemplating",
    },
    {
        Verb: "Contract",
        Present: "Contract",
        Past: "Contracted",
        Current: "Contracting",
    },
    {
        Verb: "Contrast",
        Present: "Contrast",
        Past: "Contrasted",
        Current: "Contrasting",
    },
    {
        Verb: "Contribute",
        Present: "Contribute",
        Past: "Contributed",
        Current: "Contributing",
    },
    {
        Verb: "Control",
        Present: "Control",
        Past: "Controlled",
        Current: "Controlling",
    },
    {
        Verb: "Convene",
        Present: "Convene",
        Past: "Convened",
        Current: "Convening",
    },
    {
        Verb: "Convert",
        Present: "Convert",
        Past: "Converted",
        Current: "Converting",
    },
    {
        Verb: "Convey",
        Present: "Convey",
        Past: "Conveyed",
        Current: "Conveying",
    },
    {
        Verb: "Convince",
        Present: "Convince",
        Past: "Convinced",
        Current: "Convincing",
    },
    {
        Verb: "Coordinate",
        Present: "Coordinate",
        Past: "Coordinated",
        Current: "Coordinating",
    },
    {
        Verb: "Correlate",
        Present: "Correlate",
        Past: "Correlated",
        Current: "Correlating",
    },
    {
        Verb: "Correspond",
        Present: "Correspond",
        Past: "Corresponded",
        Current: "Corresponding",
    },
    {
        Verb: "Corroborate",
        Present: "Corroborate",
        Past: "Corroborated",
        Current: "Corroborating",
    },
    {
        Verb: "Counsel",
        Present: "Counsel",
        Past: "Counseled",
        Current: "Counseling",
    },
    {
        Verb: "Create",
        Present: "Create",
        Past: "Created",
        Current: "Creating",
    },
    {
        Verb: "Critique",
        Present: "Critique",
        Past: "Critiqued",
        Current: "Critiquing",
    },
    {
        Verb: "Cultivate",
        Present: "Cultivate",
        Past: "Cultivated",
        Current: "Cultivating",
    },
    {
        Verb: "Curate",
        Present: "Curate",
        Past: "Curated",
        Current: "Curateing",
    },
    {
        Verb: "Customize",
        Present: "Customize",
        Past: "Customized",
        Current: "Customizing",
    },
    {
        Verb: "Debug",
        Present: "Debug",
        Past: "Debugged",
        Current: "Debugging",
    },
    {
        Verb: "Decide",
        Present: "Decide",
        Past: "Decided",
        Current: "Deciding",
    },
    {
        Verb: "Decode",
        Present: "Decode",
        Past: "Decoded",
        Current: "Decoding",
    },
    {
        Verb: "Decompose",
        Present: "Decompose",
        Past: "Decomposed",
        Current: "Decomposing",
    },
    {
        Verb: "Dedicate",
        Present: "Dedicate",
        Past: "Dedicated",
        Current: "Dedicating",
    },
    {
        Verb: "Deduce",
        Present: "Deduce",
        Past: "Deduced",
        Current: "Deducing",
    },
    {
        Verb: "Defer",
        Present: "Defer",
        Past: "Deferred",
        Current: "Deferring",
    },
    {
        Verb: "Define",
        Present: "Define",
        Past: "Defined",
        Current: "Defining",
    },
    {
        Verb: "Deflect",
        Present: "Deflect",
        Past: "Deflected",
        Current: "Deflecting",
    },
    {
        Verb: "Delegate",
        Present: "Delegate",
        Past: "Delegated",
        Current: "Delegating",
    },
    {
        Verb: "Deliberate",
        Present: "Deliberate",
        Past: "Deliberated",
        Current: "Deliberating",
    },
    {
        Verb: "Delineate",
        Present: "Delineate",
        Past: "Delineated",
        Current: "Delineating",
    },
    {
        Verb: "Deliver",
        Present: "Deliver",
        Past: "Delivered",
        Current: "Delivering",
    },
    {
        Verb: "Demonstrate",
        Present: "Demonstrate",
        Past: "Demonstrated",
        Current: "Demonstrating",
    },
    {
        Verb: "Demystify",
        Present: "Demystify",
        Past: "Demystified",
        Current: "Demystifying",
    },
    {
        Verb: "Depict",
        Present: "Depict",
        Past: "Depicted",
        Current: "Depicting",
    },
    {
        Verb: "Deploy",
        Present: "Deploy",
        Past: "Deployed",
        Current: "Deploying",
    },
    {
        Verb: "Deprecate",
        Present: "Deprecate",
        Past: "Deprecated",
        Current: "Deprecating",
    },
    {
        Verb: "Derive",
        Present: "Derive",
        Past: "Derived",
        Current: "Deriving",
    },
    {
        Verb: "Design",
        Present: "Design",
        Past: "Designed",
        Current: "Designing",
    },
    {
        Verb: "Designate",
        Present: "Designate",
        Past: "Designated",
        Current: "Designateing",
    },
    {
        Verb: "Detect",
        Present: "Detect",
        Past: "Detected",
        Current: "Detecting",
    },
    {
        Verb: "Deter",
        Present: "Deter",
        Past: "Deterred",
        Current: "Detering",
    },
    {
        Verb: "Determine",
        Present: "Determine",
        Past: "Determined",
        Current: "Determining",
    },
    {
        Verb: "Develop",
        Present: "Develop",
        Past: "Developed",
        Current: "Developing",
    },
    {
        Verb: "Devise",
        Present: "Devise",
        Past: "Devised",
        Current: "Devising",
    },
    {
        Verb: "Devote",
        Present: "Devote",
        Past: "Devoted",
        Current: "Devoteing",
    },
    {
        Verb: "Diagnose",
        Present: "Diagnose",
        Past: "Diagnosed",
        Current: "Diagnosing",
    },
    {
        Verb: "Differentiate",
        Present: "Differentiate",
        Past: "Differentiated",
        Current: "Differentiating",
    },
    {
        Verb: "Direct",
        Present: "Direct",
        Past: "Directed",
        Current: "Directing",
    },
    {
        Verb: "Discern",
        Present: "Discern",
        Past: "Discerned",
        Current: "Discerning",
    },
    {
        Verb: "Discover",
        Present: "Discover",
        Past: "Discovered",
        Current: "Discovering",
    },
    {
        Verb: "Dispatch",
        Present: "Dispatch",
        Past: "Dispatched",
        Current: "Dispatching",
    },
    {
        Verb: "Dissect",
        Present: "Dissect",
        Past: "Dissected",
        Current: "Dissecting",
    },
    {
        Verb: "Dissipate",
        Present: "Dissipate",
        Past: "Dissipated",
        Current: "Dissipating",
    },
    {
        Verb: "Dissuade",
        Present: "Dissuade",
        Past: "Dissuaded",
        Current: "Dissuading",
    },
    {
        Verb: "Distill",
        Present: "Distill",
        Past: "Distilled",
        Current: "Distilling",
    },
    {
        Verb: "Distinguish",
        Present: "Distinguish",
        Past: "Distinguished",
        Current: "Distinguishing",
    },
    {
        Verb: "Distribute",
        Present: "Distribute",
        Past: "Distributed",
        Current: "Distributing",
    },
    {
        Verb: "Diversify",
        Present: "Diversify",
        Past: "Diversified",
        Current: "Diversifying",
    },
    {
        Verb: "Divert",
        Present: "Divert",
        Past: "Diverted",
        Current: "Diverting",
    },
    {
        Verb: "Document",
        Present: "Document",
        Past: "Documented",
        Current: "Documenting",
    },
    {
        Verb: "Draft",
        Present: "Draft",
        Past: "Drafted",
        Current: "Drafting",
    },
    {
        Verb: "Dramatize",
        Present: "Dramatize",
        Past: "Dramatized",
        Current: "Dramatizing",
    },
    {
        Verb: "Drive",
        Present: "Drive",
        Past: "Drove",
        Current: "Driving",
    },
    {
        Verb: "Earn",
        Present: "Earn",
        Past: "Earned",
        Current: "Earning",
    },
    {
        Verb: "Eclipse",
        Present: "Eclipse",
        Past: "Eclipsed",
        Current: "Eclipsing",
    },
    {
        Verb: "Edit",
        Present: "Edit",
        Past: "Edited",
        Current: "Editing",
    },
    {
        Verb: "Educate",
        Present: "Educate",
        Past: "Educated",
        Current: "Educating",
    },
    {
        Verb: "Elicit",
        Present: "Elicit",
        Past: "Elicited",
        Current: "Eliciting",
    },
    {
        Verb: "Elucidate",
        Present: "Elucidate",
        Past: "Elucidated",
        Current: "Elucidating",
    },
    {
        Verb: "Embody",
        Present: "Embody",
        Past: "Embodied",
        Current: "Embodying",
    },
    {
        Verb: "Embrace",
        Present: "Embrace",
        Past: "Embraced",
        Current: "Embracing",
    },
    {
        Verb: "Empathize",
        Present: "Empathize",
        Past: "Empathized",
        Current: "Empathizing",
    },
    {
        Verb: "Emphasize",
        Present: "Emphasize",
        Past: "Emphasized",
        Current: "Emphasizing",
    },
    {
        Verb: "Employ",
        Present: "Employ",
        Past: "Employed",
        Current: "Employing",
    },
    {
        Verb: "Empower",
        Present: "Empower",
        Past: "Empowered",
        Current: "Empowering",
    },
    {
        Verb: "Enable",
        Present: "Enable",
        Past: "Enabled",
        Current: "Enabling",
    },
    {
        Verb: "Enact",
        Present: "Enact",
        Past: "Enacted",
        Current: "Enacting",
    },
    {
        Verb: "Encourage",
        Present: "Encourage",
        Past: "Encouraged",
        Current: "Encouraging",
    },
    {
        Verb: "Endorse",
        Present: "Endorse",
        Past: "Endorsed",
        Current: "Endorsing",
    },
    {
        Verb: "Energize",
        Present: "Energize",
        Past: "Energized",
        Current: "Energizing",
    },
    {
        Verb: "Enforce",
        Present: "Enforce",
        Past: "Enforced",
        Current: "Enforcing",
    },
    {
        Verb: "Engage",
        Present: "Engage",
        Past: "Engaged",
        Current: "Engaging",
    },
    {
        Verb: "Engineer",
        Present: "Engineer",
        Past: "Engineered",
        Current: "Engineering",
    },
    {
        Verb: "Enhance",
        Present: "Enhance",
        Past: "Enhanced",
        Current: "Enhancing",
    },
    {
        Verb: "Enlist",
        Present: "Enlist",
        Past: "Enlisted",
        Current: "Enlisting",
    },
    {
        Verb: "Ensure",
        Present: "Ensure",
        Past: "Ensured",
        Current: "Ensuring",
    },
    {
        Verb: "Entail",
        Present: "Entail",
        Past: "Entailed",
        Current: "Entailing",
    },
    {
        Verb: "Enumerate",
        Present: "Enumerate",
        Past: "Enumerated",
        Current: "Enumerating",
    },
    {
        Verb: "Equate",
        Present: "Equate",
        Past: "Equated",
        Current: "Equateing",
    },
    {
        Verb: "Equip",
        Present: "Equip",
        Past: "Equipped",
        Current: "Equipping",
    },
    {
        Verb: "Eradicate",
        Present: "Eradicate",
        Past: "Eradicated",
        Current: "Eradicating",
    },
    {
        Verb: "Erect",
        Present: "Erect",
        Past: "Erected",
        Current: "Erecting",
    },
    {
        Verb: "Escalate",
        Present: "Escalate",
        Past: "Escalated",
        Current: "Escalating",
    },
    {
        Verb: "Establish",
        Present: "Establish",
        Past: "Established",
        Current: "Establishing",
    },
    {
        Verb: "Evaluate",
        Present: "Evaluate",
        Past: "Evaluated",
        Current: "Evaluating",
    },
    {
        Verb: "Evoke",
        Present: "Evoke",
        Past: "Evoked",
        Current: "Evoking",
    },
    {
        Verb: "Evolve",
        Present: "Evolve",
        Past: "Evolved",
        Current: "Evolving",
    },
    {
        Verb: "Examine",
        Present: "Examine",
        Past: "Examined",
        Current: "Examining",
    },
    {
        Verb: "Exceed",
        Present: "Exceed",
        Past: "Exceeded",
        Current: "Exceeding",
    },
    {
        Verb: "Exclude",
        Present: "Exclude",
        Past: "Excluded",
        Current: "Excluding",
    },
    {
        Verb: "Execute",
        Present: "Execute",
        Past: "Executed",
        Current: "Executing",
    },
    {
        Verb: "Exemplify",
        Present: "Exemplify",
        Past: "Exemplified",
        Current: "Exemplifying",
    },
    {
        Verb: "Exert",
        Present: "Exert",
        Past: "Exerted",
        Current: "Exerting",
    },
    {
        Verb: "Expand",
        Present: "Expand",
        Past: "Expanded",
        Current: "Expanding",
    },
    {
        Verb: "Expedite",
        Present: "Expedite",
        Past: "Expedited",
        Current: "Expediting",
    },
    {
        Verb: "Explain",
        Present: "Explain",
        Past: "Explained",
        Current: "Explaining",
    },
    {
        Verb: "Exploit",
        Present: "Exploit",
        Past: "Exploited",
        Current: "Exploiting",
    },
    {
        Verb: "Extract",
        Present: "Extract",
        Past: "Extracted",
        Current: "Extracting",
    },
    {
        Verb: "Extrapolate",
        Present: "Extrapolate",
        Past: "Extrapolated",
        Current: "Extrapolating",
    },
    {
        Verb: "Fabricate",
        Present: "Fabricate",
        Past: "Fabricated",
        Current: "Fabricating",
    },
    {
        Verb: "Facet",
        Present: "Facet",
        Past: "Faceted",
        Current: "Faceting",
    },
    {
        Verb: "Facilitate",
        Present: "Facilitate",
        Past: "Facilitated",
        Current: "Facilitating",
    },
    {
        Verb: "Factor",
        Present: "Factor",
        Past: "Factored",
        Current: "Factoring",
    },
    {
        Verb: "Familiarize",
        Present: "Familiarize",
        Past: "Familiarized",
        Current: "Familiarizing",
    },
    {
        Verb: "Fashion",
        Present: "Fashion",
        Past: "Fashioned",
        Current: "Fashioning",
    },
    {
        Verb: "Fathom",
        Present: "Fathom",
        Past: "Fathomed",
        Current: "Fathoming",
    },
    {
        Verb: "Field",
        Present: "Field",
        Past: "Fielded",
        Current: "Fielding",
    },
    {
        Verb: "Filtrate",
        Present: "Filtrate",
        Past: "Filtrated",
        Current: "Filtrateing",
    },
    {
        Verb: "Finalize",
        Present: "Finalize",
        Past: "Finalized",
        Current: "Finalizing",
    },
    {
        Verb: "Fine-tune",
        Present: "Fine-tune",
        Past: "Fine-tuned",
        Current: "Fine-tuning",
    },
    {
        Verb: "Fine tune",
        Present: "Fine tune",
        Past: "Fine tuned",
        Current: "Fine tuning",
    },
    {
        Verb: "Finetune",
        Present: "Finetune",
        Past: "Fine Tuned",
        Current: "Fine Tuning",
    },
    {
        Verb: "Forecast",
        Present: "Forecast",
        Past: "Forecasted",
        Current: "Forecasting",
    },
    {
        Verb: "Form",
        Present: "Form",
        Past: "Formed",
        Current: "Forming",
    },
    {
        Verb: "Formulate",
        Present: "Formulate",
        Past: "Formulated",
        Current: "Formulating",
    },
    {
        Verb: "Foster",
        Present: "Foster",
        Past: "Fostered",
        Current: "Fostering",
    },
    {
        Verb: "Found",
        Present: "Found",
        Past: "Founded",
        Current: "Founding",
    },
    {
        Verb: "Fragment",
        Present: "Fragment",
        Past: "Fragmented",
        Current: "Fragmenting",
    },
    {
        Verb: "Fulfil",
        Present: "Fulfil",
        Past: "Fulfilled",
        Current: "Fulfilling",
    },
    {
        Verb: "Furnish",
        Present: "Furnish",
        Past: "Furnished",
        Current: "Furnishing",
    },
    {
        Verb: "Gain",
        Present: "Gain",
        Past: "Gained",
        Current: "Gaining",
    },
    {
        Verb: "Gather",
        Present: "Gather",
        Past: "Gathered",
        Current: "Gathering",
    },
    {
        Verb: "Gauge",
        Present: "Gauge",
        Past: "Gauged",
        Current: "Gauging",
    },
    {
        Verb: "Generate",
        Present: "Generate",
        Past: "Generated",
        Current: "Generating",
    },
    {
        Verb: "Govern",
        Present: "Govern",
        Past: "Governed",
        Current: "Governing",
    },
    {
        Verb: "Groom",
        Present: "Groom",
        Past: "Groomed",
        Current: "Grooming",
    },
    {
        Verb: "Guide",
        Present: "Guide",
        Past: "Guided",
        Current: "Guiding",
    },
    {
        Verb: "Handle",
        Present: "Handle",
        Past: "Handled",
        Current: "Handling",
    },
    {
        Verb: "Harmonize",
        Present: "Harmonize",
        Past: "Harmonized",
        Current: "Harmonizing",
    },
    {
        Verb: "Harvest",
        Present: "Harvest",
        Past: "Harvested",
        Current: "Harvesting",
    },
    {
        Verb: "Head",
        Present: "Head",
        Past: "Headed",
        Current: "Heading",
    },
    {
        Verb: "Hedge",
        Present: "Hedge",
        Past: "Hedged",
        Current: "Hedging",
    },
    {
        Verb: "Highlight",
        Present: "Highlight",
        Past: "Highlighted",
        Current: "Highlighting",
    },
    {
        Verb: "Identify",
        Present: "Identify",
        Past: "Identified",
        Current: "Identifying",
    },
    {
        Verb: "Illuminate",
        Present: "Illuminate",
        Past: "Illuminated",
        Current: "Illuminating",
    },
    {
        Verb: "Illustrate",
        Present: "Illustrate",
        Past: "Illustrated",
        Current: "Illustrating",
    },
    {
        Verb: "Imbue",
        Present: "Imbue",
        Past: "Imbued",
        Current: "Imbuing",
    },
    {
        Verb: "Immerse",
        Present: "Immerse",
        Past: "Immersed",
        Current: "Immersing",
    },
    {
        Verb: "Impact",
        Present: "Impact",
        Past: "Impacted",
        Current: "Impacting",
    },
    {
        Verb: "Implement",
        Present: "Implement",
        Past: "Implemented",
        Current: "Implementing",
    },
    {
        Verb: "Improve",
        Present: "Improve",
        Past: "Improved",
        Current: "Improving",
    },
    {
        Verb: "Incorporate",
        Present: "Incorporate",
        Past: "Incorporated",
        Current: "Incorporating",
    },
    {
        Verb: "Increase",
        Present: "Increase",
        Past: "Increased",
        Current: "Increasing",
    },
    {
        Verb: "Induce",
        Present: "Induce",
        Past: "Induced",
        Current: "Inducing",
    },
    {
        Verb: "Infer",
        Present: "Infer",
        Past: "Inferred",
        Current: "Inferring",
    },
    {
        Verb: "Influence",
        Present: "Influence",
        Past: "Influenced",
        Current: "Influencing",
    },
    {
        Verb: "Inform",
        Present: "Inform",
        Past: "Informed",
        Current: "Informing",
    },
    {
        Verb: "Initiate",
        Present: "Initiate",
        Past: "Initiated",
        Current: "Initiating",
    },
    {
        Verb: "Innovate",
        Present: "Innovate",
        Past: "Innovated",
        Current: "Innovating",
    },
    {
        Verb: "Inspect",
        Present: "Inspect",
        Past: "Inspected",
        Current: "Inspecting",
    },
    {
        Verb: "Inspire",
        Present: "Inspire",
        Past: "Inspired",
        Current: "Inspiring",
    },
    {
        Verb: "Install",
        Present: "Install",
        Past: "Installed",
        Current: "Installing",
    },
    {
        Verb: "Instigate",
        Present: "Instigate",
        Past: "Instigated",
        Current: "Instigating",
    },
    {
        Verb: "Institute",
        Present: "Institute",
        Past: "Instituted",
        Current: "Instituting",
    },
    {
        Verb: "Instruct",
        Present: "Instruct",
        Past: "Instructed",
        Current: "Instructing",
    },
    {
        Verb: "Integrate",
        Present: "Integrate",
        Past: "Integrated",
        Current: "Integrating",
    },
    {
        Verb: "Intend",
        Present: "Intend",
        Past: "Intended",
        Current: "Intending",
    },
    {
        Verb: "Interact",
        Present: "Interact",
        Past: "Interacted",
        Current: "Interacting",
    },
    {
        Verb: "Interface",
        Present: "Interface",
        Past: "Interfaced",
        Current: "Interfacing",
    },
    {
        Verb: "Interpret",
        Present: "Interpret",
        Past: "Interpreted",
        Current: "Interpreting",
    },
    {
        Verb: "Intervene",
        Present: "Intervene",
        Past: "Intervened",
        Current: "Intervening",
    },
    {
        Verb: "Interview",
        Present: "Interview",
        Past: "Interviewed",
        Current: "Interviewing",
    },
    {
        Verb: "Introduce",
        Present: "Introduce",
        Past: "Introduced",
        Current: "Introducing",
    },
    {
        Verb: "Invent",
        Present: "Invent",
        Past: "Invented",
        Current: "Inventing",
    },
    {
        Verb: "Investigate",
        Present: "Investigate",
        Past: "Investigated",
        Current: "Investigating",
    },
    {
        Verb: "Invoke",
        Present: "Invoke",
        Past: "Invoked",
        Current: "Invoking",
    },
    {
        Verb: "Isolate",
        Present: "Isolate",
        Past: "Isolated",
        Current: "Isolating",
    },
    {
        Verb: "Itemize",
        Present: "Itemize",
        Past: "Itemized",
        Current: "Itemizing",
    },
    {
        Verb: "Judge",
        Present: "Judge",
        Past: "Judged",
        Current: "Judging",
    },
    {
        Verb: "Justify",
        Present: "Justify",
        Past: "Justified",
        Current: "Justifying",
    },
    {
        Verb: "Juxtapose",
        Present: "Juxtapose",
        Past: "Juxtaposed",
        Current: "Juxtaposing",
    },
    {
        Verb: "Launch",
        Present: "Launch",
        Past: "Launched",
        Current: "Launching",
    },
    {
        Verb: "Lead",
        Present: "Lead",
        Past: "Led",
        Current: "Leading",
    },
    {
        Verb: "Lecture",
        Present: "Lecture",
        Past: "Lectured",
        Current: "Lecturing",
    },
    {
        Verb: "Ledger",
        Present: "Ledger",
        Past: "Ledgered",
        Current: "Ledgering",
    },
    {
        Verb: "Leverage",
        Present: "Leverage",
        Past: "Leveraged",
        Current: "Leveraging",
    },
    {
        Verb: "Liaise",
        Present: "Liaise",
        Past: "Liaised",
        Current: "Liaising",
    },
    {
        Verb: "Listen",
        Present: "Listen",
        Past: "Listened",
        Current: "Listening",
    },
    {
        Verb: "Localize",
        Present: "Localize",
        Past: "Localized",
        Current: "Localizing",
    },
    {
        Verb: "Magnify",
        Present: "Magnify",
        Past: "Magnified",
        Current: "Magnifying",
    },
    {
        Verb: "Maintain",
        Present: "Maintain",
        Past: "Maintained",
        Current: "Maintaining",
    },
    {
        Verb: "Manage",
        Present: "Manage",
        Past: "Managed",
        Current: "Managing",
    },
    {
        Verb: "Manipulate",
        Present: "Manipulate",
        Past: "Manipulated",
        Current: "Manipulating",
    },
    {
        Verb: "Market",
        Present: "Market",
        Past: "Marketed",
        Current: "Marketing",
    },
    {
        Verb: "Master",
        Present: "Master",
        Past: "Mastered",
        Current: "Mastering",
    },
    {
        Verb: "Maximize",
        Present: "Maximize",
        Past: "Maximized",
        Current: "Maximizing",
    },
    {
        Verb: "Measure",
        Present: "Measure",
        Past: "Measured",
        Current: "Measuring",
    },
    {
        Verb: "Mediate",
        Present: "Mediate",
        Past: "Mediated",
        Current: "Mediating",
    },
    {
        Verb: "Meditate",
        Present: "Meditate",
        Past: "Meditated",
        Current: "Meditating",
    },
    {
        Verb: "Mentor",
        Present: "Mentor",
        Past: "Mentored",
        Current: "Mentoring",
    },
    {
        Verb: "Merge",
        Present: "Merge",
        Past: "Merged",
        Current: "Merging",
    },
    {
        Verb: "Migrate",
        Present: "Migrate",
        Past: "Migrated",
        Current: "Migrating",
    },
    {
        Verb: "Minimize",
        Present: "Minimize",
        Past: "Minimized",
        Current: "Minimizing",
    },
    {
        Verb: "Mitigate",
        Present: "Mitigate",
        Past: "Mitigated",
        Current: "Mitigating",
    },
    {
        Verb: "Mobilize",
        Present: "Mobilize",
        Past: "Mobilized",
        Current: "Mobilizing",
    },
    {
        Verb: "Model",
        Present: "Model",
        Past: "Modeled",
        Current: "Modeling",
    },
    {
        Verb: "Moderate",
        Present: "Moderate",
        Past: "Moderated",
        Current: "Moderating",
    },
    {
        Verb: "Modify",
        Present: "Modify",
        Past: "Modified",
        Current: "Modifying",
    },
    {
        Verb: "Modulate",
        Present: "Modulate",
        Past: "Modulated",
        Current: "Modulating",
    },
    {
        Verb: "Mold",
        Present: "Mold",
        Past: "Molded",
        Current: "Molding",
    },
    {
        Verb: "Monitor",
        Present: "Monitor",
        Past: "Monitored",
        Current: "Monitoring",
    },
    {
        Verb: "Morph",
        Present: "Morph",
        Past: "Morphed",
        Current: "Morphing",
    },
    {
        Verb: "Motivate",
        Present: "Motivate",
        Past: "Motivated",
        Current: "Motivating",
    },
    {
        Verb: "Muster",
        Present: "Muster",
        Past: "Mustered",
        Current: "Mustering",
    },
    {
        Verb: "Navigate",
        Present: "Navigate",
        Past: "Navigated",
        Current: "Navigating",
    },
    {
        Verb: "Negotiate",
        Present: "Negotiate",
        Past: "Negotiated",
        Current: "Negotiating",
    },
    {
        Verb: "Network",
        Present: "Network",
        Past: "Networked",
        Current: "Networking",
    },
    {
        Verb: "Nominate",
        Present: "Nominate",
        Past: "Nominated",
        Current: "Nominateing",
    },
    {
        Verb: "Normalize",
        Present: "Normalize",
        Past: "Normalized",
        Current: "Normalizing",
    },
    {
        Verb: "Nourish",
        Present: "Nourish",
        Past: "Nourished",
        Current: "Nourishing",
    },
    {
        Verb: "Observe",
        Present: "Observe",
        Past: "Observed",
        Current: "Observing",
    },
    {
        Verb: "Obtain",
        Present: "Obtain",
        Past: "Obtained",
        Current: "Obtaining",
    },
    {
        Verb: "Occupy",
        Present: "Occupy",
        Past: "Occupied",
        Current: "Occupying",
    },
    {
        Verb: "Officiate",
        Present: "Officiate",
        Past: "Officiated",
        Current: "Officiateing",
    },
    {
        Verb: "Offset",
        Present: "Offset",
        Past: "Offsetted",
        Current: "Offsetting",
    },
    {
        Verb: "Omit",
        Present: "Omit",
        Past: "Omitted",
        Current: "Omitting",
    },
    {
        Verb: "Onboard",
        Present: "Onboard",
        Past: "Onboarded",
        Current: "Onboarding",
    },
    {
        Verb: "Operate",
        Present: "Operate",
        Past: "Operated",
        Current: "Operating",
    },
    {
        Verb: "Optimize",
        Present: "Optimize",
        Past: "Optimized",
        Current: "Optimizing",
    },
    {
        Verb: "Orchestrate",
        Present: "Orchestrate",
        Past: "Orchestrated",
        Current: "Orchestrating",
    },
    {
        Verb: "Organize",
        Present: "Organize",
        Past: "Organized",
        Current: "Organizing",
    },
    {
        Verb: "Orient",
        Present: "Orient",
        Past: "Oriented",
        Current: "Orienting",
    },
    {
        Verb: "Originate",
        Present: "Originate",
        Past: "Originated",
        Current: "Originating",
    },
    {
        Verb: "Outline",
        Present: "Outline",
        Past: "Outlined",
        Current: "Outlining",
    },
    {
        Verb: "Overcome",
        Present: "Overcome",
        Past: "Overcomed",
        Current: "Overcoming",
    },
    {
        Verb: "Overhaul",
        Present: "Overhaul",
        Past: "Overhauled",
        Current: "Overhauling",
    },
    {
        Verb: "Oversee",
        Present: "Oversee",
        Past: "Oversaw",
        Current: "Overseeing",
    },
    {
        Verb: "Parallel",
        Present: "Parallel",
        Past: "Paralleled",
        Current: "Paralleling",
    },
    {
        Verb: "Participate",
        Present: "Participate",
        Past: "Participated",
        Current: "Participating",
    },
    {
        Verb: "Perceive",
        Present: "Perceive",
        Past: "Perceived",
        Current: "Perceiving",
    },
    {
        Verb: "Perform",
        Present: "Perform",
        Past: "Performed",
        Current: "Performing",
    },
    {
        Verb: "Persist",
        Present: "Persist",
        Past: "Persisted",
        Current: "Persisting",
    },
    {
        Verb: "Persuade",
        Present: "Persuade",
        Past: "Persuaded",
        Current: "Persuading",
    },
    {
        Verb: "Pioneer",
        Present: "Pioneer",
        Past: "Pioneered",
        Current: "Pioneering",
    },
    {
        Verb: "Plan",
        Present: "Plan",
        Past: "Planned",
        Current: "Planning",
    },
    {
        Verb: "Portray",
        Present: "Portray",
        Past: "Portrayed",
        Current: "Portraying",
    },
    {
        Verb: "Possess",
        Present: "Possess",
        Past: "Possessed",
        Current: "Possessing",
    },
    {
        Verb: "Postulate",
        Present: "Postulate",
        Past: "Postulated",
        Current: "Postulating",
    },
    {
        Verb: "Practise",
        Present: "Practise",
        Past: "Practised",
        Current: "Practicing",
    },
    {
        Verb: "Preamble",
        Present: "Preamble",
        Past: "Preambled",
        Current: "Preambling",
    },
    {
        Verb: "Precipitate",
        Present: "Precipitate",
        Past: "Precipitated",
        Current: "Precipitating",
    },
    {
        Verb: "Predict",
        Present: "Predict",
        Past: "Predicted",
        Current: "Predicting",
    },
    {
        Verb: "Prepare",
        Present: "Prepare",
        Past: "Prepared",
        Current: "Preparing",
    },
    {
        Verb: "Prescribe",
        Present: "Prescribe",
        Past: "Prescribed",
        Current: "Prescribing",
    },
    {
        Verb: "Present",
        Present: "Present",
        Past: "Presented",
        Current: "Presenting",
    },
    {
        Verb: "Preserve",
        Present: "Preserve",
        Past: "Preserved",
        Current: "Preserving",
    },
    {
        Verb: "Preside",
        Present: "Preside",
        Past: "Presided",
        Current: "Presiding",
    },
    {
        Verb: "Prevail",
        Present: "Prevail",
        Past: "Prevailed",
        Current: "Prevailing",
    },
    {
        Verb: "Prioritize",
        Present: "Prioritize",
        Past: "Prioritized",
        Current: "Prioritizing",
    },
    {
        Verb: "Probe",
        Present: "Probe",
        Past: "Probed",
        Current: "Probing",
    },
    {
        Verb: "Problem-solve",
        Present: "Problem-solve",
        Past: "Problem-solved",
        Current: "Problem-solving",
    },
    {
        Verb: "Process",
        Present: "Process",
        Past: "Processed",
        Current: "Processing",
    },
    {
        Verb: "Procure",
        Present: "Procure",
        Past: "Procured",
        Current: "Procurement",
    },
    {
        Verb: "Produce",
        Present: "Produce",
        Past: "Produced",
        Current: "Producing",
    },
    {
        Verb: "Program",
        Present: "Program",
        Past: "Programmed",
        Current: "Programming",
    },
    {
        Verb: "Project",
        Present: "Project",
        Past: "Projected",
        Current: "Projecting",
    },
    {
        Verb: "Promote",
        Present: "Promote",
        Past: "Promoted",
        Current: "Promoting",
    },
    {
        Verb: "Propose",
        Present: "Propose",
        Past: "Proposed",
        Current: "Proposing",
    },
    {
        Verb: "Prosper",
        Present: "Prosper",
        Past: "Prospered",
        Current: "Prospering",
    },
    {
        Verb: "Prove",
        Present: "Prove",
        Past: "Proved",
        Current: "Proving",
    },
    {
        Verb: "Provide",
        Present: "Provide",
        Past: "Provided",
        Current: "Providing",
    },
    {
        Verb: "Publicize",
        Present: "Publicize",
        Past: "Publicized",
        Current: "Publicizing",
    },
    {
        Verb: "Publish",
        Present: "Publish",
        Past: "Published",
        Current: "Publishing",
    },
    {
        Verb: "Purchase",
        Present: "Purchase",
        Past: "Purchased",
        Current: "Purchasing",
    },
    {
        Verb: "Quantify",
        Present: "Quantify",
        Past: "Quantified",
        Current: "Quantifying",
    },
    {
        Verb: "Question",
        Present: "Question",
        Past: "Questioned",
        Current: "Questioning",
    },
    {
        Verb: "Raise",
        Present: "Raise",
        Past: "Raised",
        Current: "Raising",
    },
    {
        Verb: "Realize",
        Present: "Realize",
        Past: "Realized",
        Current: "Realizing",
    },
    {
        Verb: "Reason",
        Present: "Reason",
        Past: "Reasoned",
        Current: "Reasoning",
    },
    {
        Verb: "Rebrand",
        Present: "Rebrand",
        Past: "Rebranded",
        Current: "Rebranding",
    },
    {
        Verb: "Reclaim",
        Present: "Reclaim",
        Past: "Reclaimed",
        Current: "Reclaiming",
    },
    {
        Verb: "Recommend",
        Present: "Recommend",
        Past: "Recommended",
        Current: "Recommending",
    },
    {
        Verb: "Reconcile",
        Present: "Reconcile",
        Past: "Reconciled",
        Current: "Reconciling",
    },
    {
        Verb: "Record",
        Present: "Record",
        Past: "Recorded",
        Current: "Recording",
    },
    {
        Verb: "Recount",
        Present: "Recount",
        Past: "Recounted",
        Current: "Recounting",
    },
    {
        Verb: "Recruit",
        Present: "Recruit",
        Past: "Recruited",
        Current: "Recruiting",
    },
    {
        Verb: "Redesign",
        Present: "Redesign",
        Past: "Redesigned",
        Current: "Redesigning",
    },
    {
        Verb: "Reduce",
        Present: "Reduce",
        Past: "Reduced",
        Current: "Reducing",
    },
    {
        Verb: "Refactor",
        Present: "Refactor",
        Past: "Refactored",
        Current: "Refactoring",
    },
    {
        Verb: "Refer",
        Present: "Refer",
        Past: "Referred",
        Current: "Referring",
    },
    {
        Verb: "Refine",
        Present: "Refine",
        Past: "Refined",
        Current: "Refining",
    },
    {
        Verb: "Regulate",
        Present: "Regulate",
        Past: "Regulated",
        Current: "Regulating",
    },
    {
        Verb: "Rehabilitate",
        Present: "Rehabilitate",
        Past: "Rehabilitated",
        Current: "Rehabilitating",
    },
    {
        Verb: "Reinforce",
        Present: "Reinforce",
        Past: "Reinforced",
        Current: "Reinforcing",
    },
    {
        Verb: "Reiterate",
        Present: "Reiterate",
        Past: "Reiterated",
        Current: "Reiterating",
    },
    {
        Verb: "Relate",
        Present: "Relate",
        Past: "Related",
        Current: "Relateing",
    },
    {
        Verb: "Remodel",
        Present: "Remodel",
        Past: "Remodeled",
        Current: "Remodeling",
    },
    {
        Verb: "Render",
        Present: "Render",
        Past: "Rendered",
        Current: "Rendering",
    },
    {
        Verb: "Reorganize",
        Present: "Reorganize",
        Past: "Reorganized",
        Current: "Reorganizing",
    },
    {
        Verb: "Repair",
        Present: "Repair",
        Past: "Repaired",
        Current: "Repairing",
    },
    {
        Verb: "Rephrase",
        Present: "Rephrase",
        Past: "Rephrased",
        Current: "Rephrasing",
    },
    {
        Verb: "Replace",
        Present: "Replace",
        Past: "Replaced",
        Current: "Replacing",
    },
    {
        Verb: "Report",
        Present: "Report",
        Past: "Reported",
        Current: "Reporting",
    },
    {
        Verb: "Represent",
        Present: "Represent",
        Past: "Represented",
        Current: "Representing",
    },
    {
        Verb: "Repress",
        Present: "Repress",
        Past: "Repressed",
        Current: "Repressing",
    },
    {
        Verb: "Request",
        Present: "Request",
        Past: "Requested",
        Current: "Requesting",
    },
    {
        Verb: "Research",
        Present: "Research",
        Past: "Researched",
        Current: "Researching",
    },
    {
        Verb: "Reserve",
        Present: "Reserve",
        Past: "Reserved",
        Current: "Reserveing",
    },
    {
        Verb: "Resolve",
        Present: "Resolve",
        Past: "Resolved",
        Current: "Resolving",
    },
    {
        Verb: "Respond",
        Present: "Respond",
        Past: "Responded",
        Current: "Responding",
    },
    {
        Verb: "Restructure",
        Present: "Restructure",
        Past: "Restructured",
        Current: "Restructuring",
    },
    {
        Verb: "Result",
        Present: "Result",
        Past: "Resulted",
        Current: "Resulting",
    },
    {
        Verb: "Retain",
        Present: "Retain",
        Past: "Retained",
        Current: "Retaining",
    },
    {
        Verb: "Retarget",
        Present: "Retarget",
        Past: "Retargeted",
        Current: "Retargeting",
    },
    {
        Verb: "Retrieve",
        Present: "Retrieve",
        Past: "Retrieved",
        Current: "Retrieving",
    },
    {
        Verb: "Revamp",
        Present: "Revamp",
        Past: "Revamped",
        Current: "Revamping",
    },
    {
        Verb: "Reveal",
        Present: "Reveal",
        Past: "Revealed",
        Current: "Revealing",
    },
    {
        Verb: "Review",
        Present: "Review",
        Past: "Reviewed",
        Current: "Reviewing",
    },
    {
        Verb: "Revise",
        Present: "Revise",
        Past: "Revised",
        Current: "Revising",
    },
    {
        Verb: "Revitalize",
        Present: "Revitalize",
        Past: "Revitalized",
        Current: "Revitalizing",
    },
    {
        Verb: "Rewrite",
        Present: "Rewrite",
        Past: "Rewrote",
        Current: "Rewriting",
    },
    {
        Verb: "Safeguard",
        Present: "Safeguard",
        Past: "Safeguarded",
        Current: "Safeguarding",
    },
    {
        Verb: "Schedule",
        Present: "Schedule",
        Past: "Scheduled",
        Current: "Scheduling",
    },
    {
        Verb: "Screen",
        Present: "Screen",
        Past: "Screened",
        Current: "Screening",
    },
    {
        Verb: "Script",
        Present: "Script",
        Past: "Scripted",
        Current: "Scripting",
    },
    {
        Verb: "Scrutinize",
        Present: "Scrutinize",
        Past: "Scrutinized",
        Current: "Scrutinizing",
    },
    {
        Verb: "Secure",
        Present: "Secure",
        Past: "Secured",
        Current: "Securing",
    },
    {
        Verb: "Segment",
        Present: "Segment",
        Past: "Segmented",
        Current: "Segmenting",
    },
    {
        Verb: "Select",
        Present: "Select",
        Past: "Selected",
        Current: "Selecting",
    },
    {
        Verb: "Sell",
        Present: "Sell",
        Past: "Sold",
        Current: "Selling",
    },
    {
        Verb: "Sense",
        Present: "Sense",
        Past: "Sensed",
        Current: "Sensing",
    },
    {
        Verb: "Serve",
        Present: "Serve",
        Past: "Served",
        Current: "Serving",
    },
    {
        Verb: "Set Goals",
        Present: "Set Goals",
        Past: "Set Goals",
        Current: "Setting Goals",
    },
    {
        Verb: "Shape",
        Present: "Shape",
        Past: "Shaped",
        Current: "Shaping",
    },
    {
        Verb: "Share",
        Present: "Share",
        Past: "Shared",
        Current: "Sharing",
    },
    {
        Verb: "Simplify",
        Present: "Simplify",
        Past: "Simplified",
        Current: "Simplifying",
    },
    {
        Verb: "Solicit",
        Present: "Solicit",
        Past: "Solicited",
        Current: "Soliciting",
    },
    {
        Verb: "Solve",
        Present: "Solve",
        Past: "Solved",
        Current: "Solving",
    },
    {
        Verb: "Speak",
        Present: "Speak",
        Past: "Spoke",
        Current: "Speaking",
    },
    {
        Verb: "Spearhead",
        Present: "Spearhead",
        Past: "Spearheaded",
        Current: "Spearheading",
    },
    {
        Verb: "Specify",
        Present: "Specify",
        Past: "Specified",
        Current: "Specifying",
    },
    {
        Verb: "Standardize",
        Present: "Standardize",
        Past: "Standardized",
        Current: "Standardizing",
    },
    {
        Verb: "Steer",
        Present: "Steer",
        Past: "Steered",
        Current: "Steering",
    },
    {
        Verb: "Stimulate",
        Present: "Stimulate",
        Past: "Stimulated",
        Current: "Stimulating",
    },
    {
        Verb: "Strategize",
        Present: "Strategize",
        Past: "Strategized",
        Current: "Strategizing",
    },
    {
        Verb: "Streamline",
        Present: "Streamline",
        Past: "Streamlined",
        Current: "Streamlining",
    },
    {
        Verb: "Strengthen",
        Present: "Strengthen",
        Past: "Strengthened",
        Current: "Strengthening",
    },
    {
        Verb: "Structure",
        Present: "Structure",
        Past: "Structured",
        Current: "Structuring",
    },
    {
        Verb: "Study",
        Present: "Study",
        Past: "Studied",
        Current: "Studying",
    },
    {
        Verb: "Succeed",
        Present: "Succeed",
        Past: "Succeeded",
        Current: "Succeeding",
    },
    {
        Verb: "Suffice",
        Present: "Suffice",
        Past: "Sufficed",
        Current: "Sufficing",
    },
    {
        Verb: "Suggest",
        Present: "Suggest",
        Past: "Suggested",
        Current: "Suggesting",
    },
    {
        Verb: "Summarize",
        Present: "Summarize",
        Past: "Summarized",
        Current: "Summarizing",
    },
    {
        Verb: "Supersede",
        Present: "Supersede",
        Past: "Superseded",
        Current: "Superseding",
    },
    {
        Verb: "Supervise",
        Present: "Supervise",
        Past: "Supervised",
        Current: "Supervising",
    },
    {
        Verb: "Support",
        Present: "Support",
        Past: "Supported",
        Current: "Supporting",
    },
    {
        Verb: "Surpass",
        Present: "Surpass",
        Past: "Surpassed",
        Current: "Surpassing",
    },
    {
        Verb: "Survey",
        Present: "Survey",
        Past: "Surveyed",
        Current: "Surveying",
    },
    {
        Verb: "Sustain",
        Present: "Sustain",
        Past: "Sustained",
        Current: "Sustaining",
    },
    {
        Verb: "Synergize",
        Present: "Synergize",
        Past: "Synergized",
        Current: "Synergizing",
    },
    {
        Verb: "Synthesize",
        Present: "Synthesize",
        Past: "Synthesized",
        Current: "Synthesizing",
    },
    {
        Verb: "Systematize",
        Present: "Systematize",
        Past: "Systematized",
        Current: "Systematizing",
    },
    {
        Verb: "Tabulate",
        Present: "Tabulate",
        Past: "Tabulated",
        Current: "Tabulating",
    },
    {
        Verb: "Target",
        Present: "Target",
        Past: "Targeted",
        Current: "Targeting",
    },
    {
        Verb: "Teach",
        Present: "Teach",
        Past: "Taught",
        Current: "Teaching",
    },
    {
        Verb: "Test",
        Present: "Test",
        Past: "Tested",
        Current: "Testing",
    },
    {
        Verb: "Train",
        Present: "Train",
        Past: "Trained",
        Current: "Training",
    },
    {
        Verb: "Transcribe",
        Present: "Transcribe",
        Past: "Transcribed",
        Current: "Transcribing",
    },
    {
        Verb: "Transform",
        Present: "Transform",
        Past: "Transformed",
        Current: "Transforming",
    },
    {
        Verb: "Translate",
        Present: "Translate",
        Past: "Translated",
        Current: "Translating",
    },
    {
        Verb: "Transmit",
        Present: "Transmit",
        Past: "Transmitted",
        Current: "Transmitting",
    },
    {
        Verb: "Transport",
        Present: "Transport",
        Past: "Transported",
        Current: "Transporting",
    },
    {
        Verb: "Treat",
        Present: "Treat",
        Past: "Treated",
        Current: "Treating",
    },
    {
        Verb: "Troubleshoot",
        Present: "Troubleshoot",
        Past: "Troubleshooted",
        Current: "Troubleshooting",
    },
    {
        Verb: "Tutor",
        Present: "Tutor",
        Past: "Tutored",
        Current: "Tutoring",
    },
    {
        Verb: "Uncover",
        Present: "Uncover",
        Past: "Uncovered",
        Current: "Uncovering",
    },
    {
        Verb: "Undergo",
        Present: "Undergo",
        Past: "Undergoed",
        Current: "Undergoing",
    },
    {
        Verb: "Undertake",
        Present: "Undertake",
        Past: "Undertaken",
        Current: "Undertaking",
    },
    {
        Verb: "Underwrite",
        Present: "Underwrite",
        Past: "Underwrited",
        Current: "Underwriting",
    },
    {
        Verb: "Unified",
        Present: "Unified",
        Past: "Unified",
        Current: "Unifying",
    },
    {
        Verb: "Unite",
        Present: "Unite",
        Past: "United",
        Current: "Uniteing",
    },
    {
        Verb: "Update",
        Present: "Update",
        Past: "Updated",
        Current: "Updating",
    },
    {
        Verb: "Upgrade",
        Present: "Upgrade",
        Past: "Upgraded",
        Current: "Upgrading",
    },
    {
        Verb: "Uphold",
        Present: "Uphold",
        Past: "Upholded",
        Current: "Upholding",
    },
    {
        Verb: "Utilize",
        Present: "Utilize",
        Past: "Utilized",
        Current: "Utilizing",
    },
    {
        Verb: "Validate",
        Present: "Validate",
        Past: "Validated",
        Current: "Validating",
    },
    {
        Verb: "Value",
        Present: "Value",
        Past: "Valued",
        Current: "Valuing",
    },
    {
        Verb: "Venerate",
        Present: "Venerate",
        Past: "Venerated",
        Current: "Venerateing",
    },
    {
        Verb: "Verbalize",
        Present: "Verbalize",
        Past: "Verbalized",
        Current: "Verbalizing",
    },
    {
        Verb: "Verify",
        Present: "Verify",
        Past: "Verified",
        Current: "Verifying",
    },
    {
        Verb: "Vet",
        Present: "Vet",
        Past: "Vetted",
        Current: "Veting",
    },
    {
        Verb: "View",
        Present: "View",
        Past: "Viewed",
        Current: "Viewing",
    },
    {
        Verb: "Vindicate",
        Present: "Vindicate",
        Past: "Vindicated",
        Current: "Vindicating",
    },
    {
        Verb: "Vision",
        Present: "Vision",
        Past: "Visioned",
        Current: "Visioning",
    },
    {
        Verb: "Visualize",
        Present: "Visualize",
        Past: "Visualized",
        Current: "Visualizing",
    },
    {
        Verb: "Weigh",
        Present: "Weigh",
        Past: "Weighed",
        Current: "Weighing",
    },
    {
        Verb: "Wield",
        Present: "Wield",
        Past: "Wielded",
        Current: "Wielding",
    },
    {
        Verb: "Withstand",
        Present: "Withstand",
        Past: "Withstanded",
        Current: "Withstanding",
    },
    {
        Verb: "Witness",
        Present: "Witness",
        Past: "Witnessed",
        Current: "Witnessing",
    },
    {
        Verb: "Write",
        Present: "Write",
        Past: "Wrote",
        Current: "Writing",
    },
    {
        Verb: "Yield",
        Present: "Yield",
        Past: "Yielded",
        Current: "Yielding",
    },
    {
        Verb: "Source",
        Present: "Source",
        Past: "Sourced",
        Current: "Sourcing",
    },
    {
        Verb: "Discount",
        Present: "Discount",
        Past: "Discounted",
        Current: "Discounting",
    },
    {
        Verb: "Appoint",
        Present: "Appoint",
        Past: "Appointed",
        Current: "Appointing",
    },
    {
        Verb: "Involve",
        Present: "Involve",
        Past: "Involved",
        Current: "Involving",
    },
    {
        Verb: "Sponsor",
        Present: "Sponsor",
        Past: "Sponsored",
        Current: "Sponsoring",
    },
    {
        Verb: "Consult",
        Present: "Consult",
        Past: "Consulted",
        Current: "Consulting",
    },
    {
        Verb: "Lower",
        Present: "Lower",
        Past: "Lowered",
        Current: "Lowering",
    },
    {
        Verb: "Fund",
        Present: "Fund",
        Past: "Funded",
        Current: "Funding",
    },
    {
        Verb: "Certify",
        Present: "Certify",
        Past: "Certified",
        Current: "Certifying ",
    },
    {
        Verb: "Automate",
        Present: "Automate",
        Past: "Automated",
        Current: "Automating",
    },
    {
        Verb: "Scale",
        Present: "Scale",
        Past: "Scaled",
        Current: "Scaling",
    },
    {
        Verb: "Ideate",
        Present: "Ideate",
        Past: "Ideated",
        Current: "Ideating",
    },
    {
        Verb: "Invest",
        Present: "Invest",
        Past: "Invested",
        Current: "Investing",
    },
    {
        Verb: "Connect",
        Present: "Connect",
        Past: "Connected",
        Current: "Connecting",
    },
    {
        Verb: "Help",
        Present: "Help",
        Past: "Helped",
        Current: "Helping",
    },
    {
        Verb: "Craft",
        Present: "Craft",
        Past: "Crafted",
        Current: "Crafting",
    },
    {
        Verb: "Lower",
        Present: "Lower",
        Past: "Lowered",
        Current: "Lowering",
    },
    {
        Verb: "Create",
        Present: "Create",
        Past: "Crafted",
        Current: "Creating",
    },
    {
        Verb: "Propose",
        Present: "Propose",
        Past: "Proposed",
        Current: "Proposing",
    },
    {
        Verb: "Secure",
        Present: "Secure",
        Past: "Secured",
        Current: "Securing",
    },
    {
        Verb: "Vote",
        Present: "Vote",
        Past: "Voted",
        Current: "Voting",
    },
    {
        Verb: "Increase",
        Present: "Increase",
        Past: "Increased",
        Current: "Increasing",
    },
];
